<app-default-card [title]="'Meldung der Inbetriebsetzung'">
  Bitte bestätigen Sie die Daten aus dem Inbetriebsetzungsprotokolls Ihres zuständigen Elektroinstallateurs,
  um die Inbetriebsetzung abzuschließen!
</app-default-card>

<app-default-card *ngIf="model" [title]="'Daten zu Ihrer Inbetriebsetzung'">
  <section>
    <app-gr-place-in-service-summary [gr]="model"></app-gr-place-in-service-summary>
  </section>
</app-default-card>

<app-gr-place-in-service-confirmation-form
  #form
  (onErrorsChanged)="onFormErrorsChanged($event)"></app-gr-place-in-service-confirmation-form>

<app-default-card [title]="''">
  <app-form-confirmation
    [actions]="actions"
    [actionConfirm]="'PlaceInServiceConfirmed'"
    [textConfirm]="'Bestätigung absenden'"
    [actionReject]="null"
    [message]="'Sind Sie sicher, dass Sie die Daten bestätigen möchten?'"
    [errorFormList]="errorFormList"
    (onActionClickedEvent)="actionToRun($event)"></app-form-confirmation>
</app-default-card>
